/**
 * One folded question open at a time under the buy box.
 *
 * The markup already carries name="h7-pdp-folds-…", which makes a set of
 * <details> an exclusive accordion natively. That landed in Chrome 120,
 * Safari 17.2 and Firefox 130, so a shopper on anything older gets every fold
 * they have ever pressed left hanging open, pushing the answer they are
 * reading off the screen. This closes the others for them.
 *
 * Running alongside the native behaviour is harmless: both do the same thing,
 * and closing an already-closed fold is a no-op that fires no event.
 */
(() => {
  // The loading script tag lives inside the section, so an editor re-render
  // executes this file again; the delegated listener must only bind once.
  if (window.__h7PdpFoldsBound) return;
  window.__h7PdpFoldsBound = true;

  const SELECTOR = 'details[data-h7-pdp-fold]';

  // toggle does not bubble, so the listener has to be on the capture phase to
  // see it from the document. Delegated rather than bound per fold: the theme
  // editor adds and removes blocks without reloading the page.
  document.addEventListener(
    'toggle',
    (event) => {
      const fold = event.target;
      if (!fold || typeof fold.matches !== 'function' || !fold.matches(SELECTOR)) return;
      if (!fold.open) return;

      // Scoped by group name, so a second set of folds elsewhere on the page
      // would not close this one.
      const group = fold.dataset.h7PdpFold;
      document.querySelectorAll(SELECTOR).forEach((other) => {
        if (other === fold || !other.open) return;
        if (other.dataset.h7PdpFold !== group) return;
        other.open = false;
      });
    },
    true,
  );
})();
